/* eslint-disable indent */
import React, { useState } from "react";
import * as Fa from "react-icons/fa";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import XLSX from "xlsx";
import { toast } from "react-toastify";
import storage from "../../../Services/Storage";
import { createAPIEndpoint, Endpoint } from "../../../Services/stockreport/StockReport";
import Loader from "../../../Components/Loader";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";

const StockInHandNonInventory = () => {

    const [stockProductData, setStockProductData] = useState();
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [loadingExcel1, setLoadingExcel1] = useState(false);
    const [productCode, setProductCode] = useState("");
    const auth = storage.getLocal("user");

    const handleInputChange = (e) => {
        setProductCode(e.target.value);
    };

    const handleExportExcel = () => {
        // console.log("calling");
        setLoadingExcel1(true);

        let uniqueNo = `StockInHandNonInv${GetDateFormat()}`;
        createAPIEndpoint().get(`${Endpoint.GetStockDataExcelNI}?CICode=${auth.CICode}&Checked=N&CompId=${auth.CompId}`)

            .then((val) => {
                if (val.data.StockDataNI.length > 0) {
                    var wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.json_to_sheet(val.data.StockDataNI);
                    XLSX.utils.book_append_sheet(wb, ws, uniqueNo);
                    XLSX.writeFile(wb, `${uniqueNo}.xlsx`);
                }
                else {
                    toast.warning(
                        "No data found between these dates",
                        {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        });
                }
                setLoadingExcel1(false);

            }).catch((err) => {
                console.log("error ",err);

                toast.error(
                    `${err.response.data}`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    }

                );
                setLoadingExcel1(false);
            });
    };

    const getGetStockDataNonInv = () => {
        if(productCode.trim().length==0){
            toast.warn("Please enter product code",{
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        setLoadingExcel(false);
        createAPIEndpoint().get(`${Endpoint.GetStockDataNonInv}?CICode=${auth.CICode}&Prod_Code=${productCode}&Checked=N&strCompId=${auth.CompId}`)

            .then((val) => {
                if (val.data.StockDataNI.length > 0) {
                    setStockProductData(val.data.StockDataNI);
                }
                else {
                    toast.warning(
                        "No data found between these dates",
                        {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        });
                }
                setLoadingExcel(false);

            }).catch((err) => {

                toast.error(
                    `${err.response.data}`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    }

                );
                setLoadingExcel(false);
            });
    };

    return (
        <>
            

                    <div className="col-12 pt-0 pb-4">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <h3 className="py-2">Stock In Hand Non Inventory</h3>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="float-end mb-2">
                                    <button type="button" title="Export All" className="btn btn-primary" onClick={handleExportExcel} disabled={loadingExcel1}>
                                        {/* Export All <Fa.FaFileExport className="ms-2" /> */}
                                        {loadingExcel1 ? "Loading..." : "Export All"}{" "}
                                                                                    {loadingExcel1 ? (
                                                                                        <span
                                                                                            className="spinner-border spinner-border-sm"
                                                                                            role="status"
                                                                                            aria-hidden="true"
                                                                                        ></span>
                                                                                    ) : (
                                                                                        <Fa.FaDownload className="ms-2" />
                                                                                    )}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <section className="sales-box">
                            <form>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <label className="form-label">Product Code</label>
                                        <input type="text" placeholder="Enter product code"
                                            className="form-control" value={productCode}
                                            onChange={handleInputChange} />
                                    </div>

                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="float-end mt-4">
                                            <button type="button" title=" Get Stock Data " className="btn btn-primary mt-1" onClick={getGetStockDataNonInv} >
                                                
                                                Get Stock data
                                            </button>
                                        </div>

                                    </div>

                                </div>
                            </form>
                        </section>
                        {loadingExcel?<><Loader/></>:<section className="">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                            <h3 className="py-2">Records</h3>
                                <div className="DataTable">
                                    <DataTable
                                        paginator
                                        rows={10}
                                        value={stockProductData}
                                        filterDisplay="row"
                                        rowsPerPageOptions={[10, 25, 50]}
                                        scrollHeight="80vh"
                                        // showGridlines
                                        scrollable
                                        stripedRows
                                        fil
                                        emptyMessage="No Record found"
                                    >
                                        <Column field="STK_PROD_ID" header="Product Code"
                                        ></Column>
                                        <Column field="PROD_SMALL_DESC" header="Product Description"
                                        />
                                        <Column field="LOCATION_DESC" header="Location "
                                            filter
                                            filterPlaceholder="Search Here..."></Column>
                                        <Column field="STK_TYPE_DESC" header="Stock Type "
                                            filter
                                            filterPlaceholder="Search Here..."></Column>
                                        <Column field="WH_DESC" header="Warehouse"
                                            filter
                                            filterPlaceholder="Search Here..."></Column>
                                        <Column field="PROD_BATCH_NO" header="Lot No"
                                            filter
                                            filterPlaceholder="Search Here..."></Column>
                                        <Column field="QTY_PACK" header="Qty(Pack)"
                                        ></Column>




                                    </DataTable>
                                </div>
                            </div>
                        </section>}
                    </div>
                            
        </>
    );

};

export default StockInHandNonInventory;